import React from 'react';

interface ContextMenuContextType {
  /**
   * To be used when an option has shouldHideInsteadOfCloseMenu set
   * With this option enabled, the devloper must manually close the menu when
   * ready
   */
  closeMenu: () => void;
  hideMenu: () => void;
}

const ContextMenuContext = React.createContext<ContextMenuContextType>({
  closeMenu: () => {},
  hideMenu: window.tokenFunction,
});

export default ContextMenuContext;
